import React from "react";
import { HiOutlineChevronLeft, HiOutlineChevronRight } from "react-icons/hi";

function DaySelector({ selectedDay, setSelectedDay, days }) {
  const handleLeftArrowClick = () => {
    const index = days.indexOf(selectedDay);
    if (index === 0) {
      setSelectedDay(days[days.length - 1]);
      return;
    }
    setSelectedDay(days[index - 1]);
  };
  const handleRightArrowClick = () => {
    const index = days.indexOf(selectedDay);
    if (index === days.length - 1) {
      setSelectedDay(days[0]);
      return;
    }
    setSelectedDay(days[index + 1]);
  };
  return (
    <div className="day-selector-container">
      <div className="day-selector-content-container">
        <HiOutlineChevronLeft
          onClick={() => handleLeftArrowClick()}
          className="day-selector-arrows"
          size={50}
        />
        <span>{selectedDay}</span>
        <HiOutlineChevronRight
          onClick={() => handleRightArrowClick()}
          className="day-selector-arrows"
          size={50}
        />
      </div>
    </div>
  );
}

export default DaySelector;
